import { ShieldCheck, Award } from "lucide-react";
import { Reveal, Label } from "./motion";
import { TRAINER } from "../data";

const CRED_ICONS = [Award, ShieldCheck];

export const About = () => (
  <section id="about" className="px-4 md:px-8 lg:px-12 py-24 md:py-32 lg:py-48" data-testid="about-section">
    <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
      <div>
        <Reveal><Label>01 — About</Label></Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[0.9] mt-6 text-white">
            Coaching with<br /><span className="text-[#FF3B30]">intent.</span>
          </h2>
        </Reveal>
        {TRAINER.bio.map((p, i) => (
          <Reveal key={i} delay={0.2 + i * 0.1}>
            <p className="text-zinc-400 text-base lg:text-lg mt-6 leading-relaxed max-w-xl">{p}</p>
          </Reveal>
        ))}

        <Reveal delay={0.35}>
          <div className="flex flex-wrap gap-3 mt-8" data-testid="credentials">
            {TRAINER.credentials.map((c, i) => {
              const Icon = CRED_ICONS[i % CRED_ICONS.length];
              return (
                <div key={c} className="flex items-center gap-2.5 border border-zinc-800 bg-[#121212] px-4 py-2.5" data-testid={`credential-${i}`}>
                  <Icon size={16} className="text-[#FF3B30]" />
                  <span className="text-xs uppercase tracking-widest text-zinc-200 font-medium">{c}</span>
                </div>
              );
            })}
          </div>
        </Reveal>

        <div className="grid grid-cols-3 gap-6 mt-12 border-t border-zinc-800 pt-10">
          {TRAINER.stats.map((s, i) => (
            <Reveal key={i} delay={0.3 + i * 0.1}>
              <div className="font-display text-4xl lg:text-5xl text-white">{s.value}</div>
              <div className="text-xs uppercase tracking-widest text-zinc-500 mt-2">{s.label}</div>
            </Reveal>
          ))}
        </div>
      </div>

      <Reveal delay={0.15} className="relative">
        <div className="relative overflow-hidden">
          <img src={TRAINER.portrait} alt={TRAINER.name} className="w-full h-[520px] lg:h-[640px] object-cover object-top grayscale hover:grayscale-0 transition-[filter] duration-700" />
          <div className="absolute inset-0 border border-zinc-700 pointer-events-none" />
        </div>
        <div className="absolute -bottom-5 -left-3 bg-[#FF3B30] text-white px-6 py-4">
          <div className="font-display text-lg leading-none">{TRAINER.name}</div>
          <div className="text-[10px] uppercase tracking-widest mt-1 opacity-90">{TRAINER.role}</div>
        </div>
      </Reveal>
    </div>
  </section>
);
